import {
  Avatar,
  Checkbox,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  ListItemTextProps,
  ListProps,
  Stack,
} from '@mui/material';
import { FunctionComponent } from 'react';
import { CheckboxItemSkeleton } from './checkbox-item-skeleton';

export type CheckBoxListPros = {
  checked: Map<string, any>;
  items: ({ avatarSrc?: string; id: string; data?: any } & Omit<
    ListItemTextProps,
    'id'
  >)[];
  skeletonItems?: number;
  listProps?: ListProps;
  loading?: boolean;
  onClickItem: (params: { id: string; data?: any }) => void;
};

export const CheckBoxList: FunctionComponent<CheckBoxListPros> = (props) => {
  const { checked, items, listProps, loading, onClickItem, skeletonItems } =
    props;

  if (loading && skeletonItems) {
    return (
      <Stack direction="column" spacing={1}>
        {Array.from(new Array(skeletonItems)).map((index) => (
          <CheckboxItemSkeleton key={index} />
        ))}
      </Stack>
    );
  }

  return (
    <List dense {...listProps}>
      {items.map(({ avatarSrc, data, id, ...itemProps }, index) => {
        return (
          <ListItem
            key={index}
            secondaryAction={<Checkbox edge="end" checked={checked.has(id)} />}
            onClick={() => onClickItem({ data, id })}
            disablePadding
          >
            <ListItemButton>
              <ListItemAvatar>
                <Avatar src={avatarSrc} />
              </ListItemAvatar>
              <ListItemText id={id} {...itemProps} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};
